import React, { useState } from "react";
import axios from "axios";
import {
  Button,
  Tr,
  Td,
  Spinner,
  HStack,
  Checkbox,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Text,
  Tooltip,
  IconButton,
} from "@chakra-ui/react";
import { VendorSelect } from "../account/vendorDropDown";
import {
  isTransactionAdded,
  isTransactionLinked,
  oppositeType,
  renderAmount,
} from "../../utils";
import { DropDown } from "../generic/dropDown";
import { CheckCircle, Link, MoreVertical } from "react-feather";
import { GenericModal } from "../generic/modal";

export const TransactionList = ({
  transactions,
  bankAccount,
  accountList,
  replaceTransaction,
  splitTransaction,
  linkTransaction,
  customer_id,
  includeExcluded,
  recon = false,
}) => {
  const [loading, setLoading] = useState([]);
  const [selected, setSelected] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteTargets, setDeleteTargets] = useState([]);

  const getSelectedAccount = (transaction) => {
    for (let entry of transaction.journal_entries) {
      if (entry.account !== bankAccount.accounting_account.id) {
        return entry.account;
      }
    }
  };

  // TODO: we need to refactor and move the update journal entry and vendor logic to the backend

  const getTransactionUpdateData = (account, transaction) => {
    var data = { journal_entries: [] };
    if (transaction.journal_entries.length > 0) {
      var entry = transaction.journal_entries.find((e) => {
        return e.account !== bankAccount.accounting_account.id;
      });
      entry.account = account.value;
      entry.user_updated = true;
      data.journal_entries.push(entry);
    } else {
      const account_type = bankAccount.accounting_account.account_type;
      let bank_account_type =
        transaction.amount <= 0 ? account_type : oppositeType(account_type);
      if (account_type === "credit") {
        bank_account_type =
          transaction.amount <= 0 ? oppositeType(account_type) : account_type;
      }
      data.journal_entries.push({
        customer: customer_id,
        account: bankAccount.accounting_account.id,
        entry_type: bank_account_type,
        date: transaction.date,
        amount: Math.abs(transaction.amount),
        description: transaction.description ?? transaction.name,
        added: false,
        user_updated: true,
      });
      data.journal_entries.push({
        customer: customer_id,
        account: account.value,
        entry_type: oppositeType(bank_account_type),
        date: transaction.date,
        amount: Math.abs(transaction.amount),
        description: transaction.description ?? transaction.name,
        added: false,
      });
    }
    return data;
  };

  const updateJournalEntry = (account, transaction) => {
    if (isSelected(transaction)) {
      const data = transactions
        .filter((t) => isSelected(t))
        .map((t) => {
          var tdata = getTransactionUpdateData(account, t);
          tdata.transaction_id = t.id;
          return tdata;
        });

      bulkUpdateTransactions(data);
    } else {
      const data = getTransactionUpdateData(account, transaction);
      updateTransaction(transaction, data);
    }
  };

  const updateExclude = (transaction) => {
    if (isSelected(transaction)) {
      const data = transactions
        .filter((t) => isSelected(t))
        .map((t) => {
          return {
            transaction_id: t.id,
            is_excluded: !transaction.is_excluded,
          };
        });
      bulkUpdateTransactions(data, includeExcluded ? "replace" : "remove");
    } else {
      updateTransaction(
        transaction,
        { is_excluded: !transaction.is_excluded },
        includeExcluded ? "replace" : "remove"
      );
    }
  };

  const updateVendor = (vendor, transaction) => {
    if (isSelected(transaction)) {
      const data = transactions
        .filter((t) => isSelected(t))
        .map((t) => {
          var inner_data = {};
          if (vendor.account) {
            inner_data = getTransactionUpdateData({ value: vendor.account }, t);
          }
          return { transaction_id: t.id, vendor: vendor.value, ...inner_data };
        });
      bulkUpdateTransactions(data);
    } else {
      var data = {
        vendor: vendor.value,
        ...(vendor.account
          ? getTransactionUpdateData({ value: vendor.account }, transaction)
          : {}),
      };
      if (transaction.journal_entries.length > 0) {
        data["id"] = transaction.journal_entries[0].id;
      }
      updateTransaction(transaction, data);
    }
  };

  const addJournalEntry = (transaction) => {
    if (isSelected(transaction)) {
      const data = transactions
        .filter((t) => isSelected(t))
        .map((t) => {
          var entries = [];
          for (let entry of t.journal_entries) {
            entry.added = true;
            entries.push(entry);
          }
          return { transaction_id: t.id, journal_entries: entries };
        });
      bulkUpdateTransactions(data, recon ? "replace" : "remove");
    } else {
      var data = { journal_entries: [] };
      for (let entry of transaction.journal_entries) {
        entry.added = true;
        data.journal_entries.push(entry);
      }
      updateTransaction(transaction, data, recon ? "replace" : "remove");
    }
  };

  const updateTransaction = (transaction, data, action = "replace") => {
    setLoading((prevList) => [...prevList, transaction.id]);
    axios
      .patch(
        `/api/v2/bankaccounts/${transaction.bankaccount}/transactions/${transaction.id}/`,
        data
      )
      .then((res) => {
        replaceTransaction(res.data, action);
        setLoading((prevList) => prevList.filter((t) => transaction.id !== t));
      })
      .catch((err) => console.log(err));
  };

  const bulkUpdateTransactions = (data, action = "replace") => {
    const ids = data.map((t) => t.id);
    setLoading((prevList) => prevList.concat([...ids]));
    axios
      .patch(`/api/v2/bulktransactions/`, data)
      .then((res) => {
        replaceTransaction(res.data, action);
        setLoading((prevList) => prevList.filter((t) => ids.indexOf(t) !== -1));
      })
      .catch((err) => console.log(err));
  };

  const classifyTransaction = (transaction) => {
    var transactionIds = [transaction.id];
    setLoading((prevList) => prevList.concat([...transactionIds]));
    if (isSelected(transaction)) {
      transactionIds = transactions
        .filter((t) => isSelected(t))
        .map((t) => {
          return t.id;
        });
    }

    axios
      .post(`/api/v2/classifytransactions/`, {
        transaction_ids: transactionIds,
      })
      .then((res) => {
        replaceTransaction(res.data, "replace");
        setLoading([]);
      })
      .catch((err) => console.log(err));
  };

  const isLoading = (t) => {
    return loading.indexOf(t.id) !== -1;
  };

  const deleteTransaction = (transaction) => {
    // Only allowed for excluded transactions
    if (!transaction.is_excluded) return;
    if (isSelected(transaction)) {
      const targets = transactions.filter(
        (t) => isSelected(t) && t.is_excluded
      );
      setDeleteTargets(targets);
    } else {
      setDeleteTargets([transaction]);
    }
    setIsDeleteModalOpen(true);
  };

  const confirmDeleteTransactions = () => {
    if (!deleteTargets || deleteTargets.length === 0) {
      setIsDeleteModalOpen(false);
      return;
    }
    if (deleteTargets.length > 1) {
      const data = deleteTargets.map((t) => ({
        transaction_id: t.id,
        is_deleted: true,
        is_excluded: true,
      }));
      bulkUpdateTransactions(data, "remove");
    } else {
      const t = deleteTargets[0];
      updateTransaction(t, { is_deleted: true, is_excluded: true }, "remove");
    }
    setIsDeleteModalOpen(false);
    setDeleteTargets([]);
  };

  const isSelected = (t) => {
    return selected.indexOf(t.id) !== -1;
  };

  const selectTransaction = (transaction, e) => {
    if (e.target.checked && e.nativeEvent.shiftKey && selected.length > 0) {
      var on = false;
      for (let t of transactions) {
        if (selected.indexOf(t.id) !== -1) {
          on = true;
        }

        if (on) {
          setSelected((prev) => [...prev, t.id]);
        }

        if (t.id === transaction.id) {
          on = false;
        }
      }
    } else {
      if (e.target.checked) {
        setSelected((prev) => [...prev, transaction.id]);
      } else {
        setSelected((prev) => prev.filter((id) => id !== transaction.id));
      }
    }
  };

  const isDeleting = deleteTargets.some((t) => isLoading(t));

  return (
    <>
      <TransactionDeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => {
          setIsDeleteModalOpen(false);
          setDeleteTargets([]);
        }}
        targets={deleteTargets}
        isDeleting={isDeleting}
        onConfirm={confirmDeleteTransactions}
      />
      {transactions &&
        transactions.map((transaction) => (
          <Tr
            key={transaction.id}
            color={transaction.is_excluded ? "lightgray" : "black"}
          >
            <Td p="2">
              <Checkbox
                isChecked={isSelected(transaction)}
                onChange={(e) => selectTransaction(transaction, e)}
              />
            </Td>
            <Td p="2">{transaction.date}</Td>
            <Td p="2">
              <Tooltip
                label={
                  <>
                    <Text>{transaction.description ?? transaction.name}</Text>
                    <Text fontSize="xs" color="gray.500">
                      Double-click to Google
                    </Text>
                  </>
                }
                placement="top"
              >
                <Text
                  width="200px"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace="nowrap"
                  cursor="pointer"
                  onDoubleClick={() => {
                    const query = transaction.description ?? transaction.name ?? "";
                    window.open(
                      `https://www.google.com/search?q=${encodeURIComponent(
                        query
                      )}`,
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }}
                >
                  {transaction.description ?? transaction.name}
                </Text>
              </Tooltip>
            </Td>
            <Td p="2">
              <VendorSelect
                selectedVendorID={transaction.vendor}
                onChange={updateVendor}
                metaData={transaction}
                menuPortalTarget={document.body}
                w="250px"
              />
            </Td>
            <Td p="2">
              <DropDown
                name="account"
                options={accountList}
                selectedValue={getSelectedAccount(transaction)}
                onChange={updateJournalEntry}
                metaData={transaction}
                menuPortalTarget={document.body}
                w="350px"
              />
            </Td>
            <Td textAlign={"right"} p="2">
              {transaction.amount > 0 &&
                renderAmount(Math.abs(transaction.amount))}
            </Td>
            <Td textAlign={"right"} p="2">
              {transaction.amount <= 0 &&
                renderAmount(Math.abs(transaction.amount))}
            </Td>
            <Td p="2">
              <HStack p="0" direction="row" spacing={2} align="center">
                {!isTransactionAdded(transaction) && (
                  <Menu>
                    <MenuButton
                      as={Button}
                      rounded={"full"}
                      variant={"link"}
                      cursor={"pointer"}
                      minW={0}
                    >
                      <MoreVertical />
                    </MenuButton>
                    <MenuList zIndex={99999}>
                      {splitTransaction && (
                        <MenuItem onClick={() => splitTransaction(transaction)}>
                          Split
                        </MenuItem>
                      )}
                      {linkTransaction && (
                        <MenuItem onClick={() => linkTransaction(transaction)}>
                          Link
                        </MenuItem>
                      )}
                      <MenuItem onClick={() => updateExclude(transaction)}>
                        {transaction.is_excluded ? "Include" : "Exclude"}
                      </MenuItem>
                      {transaction.is_excluded && (
                        <MenuItem
                          onClick={() => deleteTransaction(transaction)}
                        >
                          Delete
                        </MenuItem>
                      )}
                    </MenuList>
                  </Menu>
                )}
                {isTransactionLinked(transaction) &&
                  !isTransactionAdded(transaction) &&
                  !isLoading(transaction) && (
                    <Button
                      colorScheme="brand"
                      onClick={() => addJournalEntry(transaction)}
                    >
                      Add
                    </Button>
                  )}
                {!isTransactionAdded(transaction) &&
                  !isTransactionLinked(transaction) &&
                  !isLoading(transaction) && (
                    <IconButton
                      icon={<Link />}
                      variant="outline"
                      aria-label="Auto assign"
                      onClick={() => classifyTransaction(transaction)}
                    />
                  )}
                {recon && isTransactionAdded(transaction) && (
                  <CheckCircle color={"green"} />
                )}
                {isLoading(transaction) && <Spinner color="brand.600" />}
              </HStack>
            </Td>
          </Tr>
        ))}
    </>
  );
};

const TransactionDeleteModal = ({
  isOpen,
  onClose,
  targets,
  isDeleting,
  onConfirm,
}) => {
  return (
    <GenericModal
      isOpen={isOpen}
      onClose={onClose}
      title={`Delete ${targets.length > 1 ? "transactions" : "transaction"}?`}
      loading={isDeleting}
      body={
        <Text>
          {targets.length > 1
            ? `Are you sure you want to delete ${targets.length} excluded transactions?`
            : "Are you sure you want to delete this excluded transaction?"}
        </Text>
      }
      submitButton={
        <Button
          colorScheme="red"
          onClick={onConfirm}
          isLoading={isDeleting}
          ml={"3"}
        >
          Delete
        </Button>
      }
    />
  );
};
